$(function(){
    
    $(".owl-carousel-gallery").each(function(){

        let owl_wrapper = $(this);
        let owl_product_images = $(this).find('.gallery-product-images');
        let owl_thumbnail_images = $(this).find('.gallery-thumbnails');
        let owl_next_btn = $(this).find('.gallery-next-btn');
        let owl_prev_btn = $(this).find('.gallery-prev-btn');

        owl_product_images.owlCarousel({
            responsive : {
                0 : {
                    items: 1,
                    margin: 1,
                    dots: true,
                },
                750 : {
                    items: 1,
                    margin: 1,
                    dots: false,
                },
            }
        });

        owl_thumbnail_images.owlCarousel({
            items: 5,
            dots: false,
            loop: true,
            margin: 1,
            mouseDrag: false,
            touchDrag: false,
        });

        // set inital thumbnail index
        owl_thumbnail_images.trigger('prev.owl.carousel');
        owl_thumbnail_images.trigger('prev.owl.carousel');

        let current_item = 0;
        let last_item_index = owl_product_images.find('.owl-item').length - 1;

        owl_product_images.on("dragged.owl.carousel", function (event) {
            if(current_item < event.item.index){
                owl_thumbnail_images.trigger('next.owl.carousel');
            }
            if(current_item > event.item.index){
                owl_thumbnail_images.trigger('prev.owl.carousel');
            }
            current_item = event.item.index;
            select_thumbnail(owl_thumbnail_images);
        });

        owl_wrapper.css({
            'display':'none',
            'opacity':1
        });

        select_thumbnail(owl_thumbnail_images);        

        add_thumbnail_event_listeners(owl_thumbnail_images);

        owl_next_btn.click('on',function(){
            owl_thumbnail_images.trigger('next.owl.carousel');
            increment_product_images_slider();
            select_thumbnail(owl_thumbnail_images);
        });

        owl_prev_btn.click('on',function(){
            owl_thumbnail_images.trigger('prev.owl.carousel');
            decrement_product_images_slider();
            select_thumbnail(owl_thumbnail_images);
        });

        owl_product_images.on('refreshed.owl.carousel', function(event) {
            setTimeout(function(){
                select_thumbnail(owl_thumbnail_images);
                add_thumbnail_event_listeners(owl_thumbnail_images);
            },250);
            
        });

        function decrement_product_images_slider(){
            if(current_item == 0){
                owl_product_images.trigger('to.owl.carousel', [(last_item_index), 300]);
                current_item = last_item_index;
            } else {
                owl_product_images.trigger('prev.owl.carousel');
                current_item = current_item - 1;
            }
        }

        function increment_product_images_slider(){
            if(current_item == last_item_index){
                owl_product_images.trigger('to.owl.carousel', [0, 300]);
                current_item = 0;
            } else {
                owl_product_images.trigger('next.owl.carousel');
                current_item = current_item + 1;
            }
        }

        // add selected class to middle thumbnail (3rd one along with a class of active in a 5 thumbnail slider)
        function select_thumbnail(owl_thumbnail_images){
            let active_thumbnail_count = 0;
            owl_thumbnail_images.find('.owl-item').removeClass('selected');
            owl_thumbnail_images.find('.owl-item.active').each(function(){
                active_thumbnail_count++;
                $(this).data('active-index',active_thumbnail_count);
                if(active_thumbnail_count == 3){
                    $(this).addClass('selected');
                }            
            });
        }

        function add_thumbnail_event_listeners(owl_thumbnail_images){
            owl_thumbnail_images.find('.owl-item').off('click');
            owl_thumbnail_images.find('.owl-item').on('click',function(){
                switch($(this).data('active-index')){
                    case 1:
                        owl_thumbnail_images.trigger('prev.owl.carousel');
                        owl_thumbnail_images.trigger('prev.owl.carousel');
                        decrement_product_images_slider();
                        decrement_product_images_slider();
                        break;
                    case 2:
                        owl_thumbnail_images.trigger('prev.owl.carousel');
                        decrement_product_images_slider();
                        break;
                    case 4:
                        owl_thumbnail_images.trigger('next.owl.carousel');
                        increment_product_images_slider();
                        break;
                    case 5:
                        owl_thumbnail_images.trigger('next.owl.carousel');
                        owl_thumbnail_images.trigger('next.owl.carousel');
                        increment_product_images_slider();
                        increment_product_images_slider();
                        break;
                }
                select_thumbnail(owl_thumbnail_images);
            });
        }

    });    

});